export default "__VITE_ASSET__CZFKWzyV__"